import { render, staticRenderFns } from "./RemindersQuickAdd.vue?vue&type=template&id=6eb2bf94&scoped=true&"
import script from "./RemindersQuickAdd.vue?vue&type=script&lang=js&"
export * from "./RemindersQuickAdd.vue?vue&type=script&lang=js&"
import style0 from "./RemindersQuickAdd.vue?vue&type=style&index=0&id=6eb2bf94&prod&scoped=true&lang=css&"
import style1 from "./RemindersQuickAdd.vue?vue&type=style&index=1&id=6eb2bf94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2bf94",
  null
  
)

export default component.exports